// extracted by mini-css-extract-plugin
export var blank = "polylink-module--blank--93a79";
export var withoutIcon = "polylink-module--withoutIcon--2f9a3";